var _desc, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFfclock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 320 320)",
    id: "SD0dU4BnMQjCPdpoO7Ayj"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -1.35 -1.52)",
    id: "8J4xJFdSQIQ_Z2GoTD4gS"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-248.65, -248.48)",
    d: "M 248.649 4.394 C 383.363 4.394 492.734 113.765 492.734 248.479 C 492.734 383.193 383.363 492.564 248.649 492.564 C 113.934 492.564 4.563 383.193 4.563 248.479 C 4.563 113.765 113.934 4.394 248.649 4.394 Z M 247.227 51.157 C 356.393 51.157 445.023 139.786 445.023 248.953 C 445.023 358.119 356.393 446.749 247.227 446.749 C 138.06 446.749 49.431 358.119 49.431 248.953 C 49.431 139.786 138.06 51.157 247.227 51.157 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -14.26 -39.15)",
    id: "o9TYayFbfXypUQC_ip5-X"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(132,24,38)",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5,
      fill: "rgb(132,24,38)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-235.74, -210.85)",
    d: "M 187.679 284.024 L 277.756 284.024 C 277.756 284.024 286.039 285.059 288.109 277.812 L 288.109 141.661 C 288.109 141.661 272.061 132.602 254.978 141.661 L 254.978 248.821 L 185.867 248.821 C 185.867 248.821 180.254 261.795 185.867 284.051 L 187.679 284.024 Z",
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFfclock);
export default __webpack_public_path__ + "static/media/ffclock.bf406ecebc81128f767a558262c93832.svg";
export { ForwardRef as ReactComponent };